// import { createSelector } from 'reselect';
import { PRO_REDUCER } from './reducer';

export const selectOtherProById = (state, userId) =>
  state[PRO_REDUCER].pros[userId];

export const selectRecurringProServicePresets = (state) =>
  state[PRO_REDUCER].recurringPresets;
